import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
  getDoneFieldWorks: {
    apiServiceMethodName:
      ModulesConfigMap[ModulesMap.DONE_WORKS_DONE_FIELD_WORKS].GET_DONE_FIELD_WORKS
  },
}